import {
    Frame,
    Page,
    TextField,
    LegacyCard,
    PageActions,
    DescriptionList,
    Toast,
} from "@shopify/polaris";
import { useCallback, useEffect, useState } from "react";
import Api from '../../helpers/api';

const SendQuote = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    const [draftOrder, setDraftOrder] = useState(null);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({
        active: false,
        content: "",
        duration: null
    });

    // Getting the customer from the router parameter.
    useEffect(() => {
        setLoading(true);
        Api.getDraftOrder(id)
            .then(item => {
                setDraftOrder(item.data.draft_order);
                setEmail(item.data.draft_order?.email ?? '');
                setLoading(false);
            })
    }, []);

    const sendQuote = useCallback(() => {
        console.log(email);
        if (!email || email.length == 0) {
            alert('Email is required');
            return;
        }
        setLoading(true);

        Api
            .sendQuote({
                id: id,
                email: email
            })
            .then(() => {
                showToast("Quote sent");
            })
            .catch((error) => {
                const errors = error.response.data.errors ?? [];
                showToast(errors.join(','), 10000);
            })
            .finally(() => setLoading(false))
    }, [email]);

    const showToast = useCallback((content, duration = null) => setToast({active: true, content: content ?? "", duration: duration}), []);
    const hideToast = useCallback(() => setToast({active: false, content: "", duration: null}), []);
    const toastMarkup = toast.active ? (
        <Toast content={toast.content} onDismiss={hideToast} duration={toast.duration} />
    ) : null;

    return (
        <Frame>
            <Page title={`Send Quote`}>
                <LegacyCard sectioned>
                    <DescriptionList items={[
                        {term: 'Name', description: draftOrder?.name },
                        {term: 'Company Name', description: draftOrder?.customer?.first_name + ' ' + draftOrder?.customer?.last_name },
                    ]} />
                    <LegacyCard.Section>
                        <TextField label="Email" value={email} onChange={setEmail} />
                    </LegacyCard.Section>
                </LegacyCard>

                <PageActions
                    primaryAction={[
                        {
                            content: 'Send Quote',
                            onAction: sendQuote,
                            loading: loading
                        },
                    ]}
                />
                {toastMarkup}
            </Page>
        </Frame>
    );
}

export default SendQuote;
